import React from 'react'
import OrderFailed from '../../../components/pages/Shop/OrderFailed'
import SEO from '../../../components/SEO'
import ShopLayout from '../../../layouts/ShopLayout'

const OrderFailedPage = () => <ShopLayout>
  <SEO noIndex />
  <OrderFailed />
</ShopLayout>


export default OrderFailedPage
